<div class="hint-wrapper" *ngIf="showTooltip">
  <div class="hint">
    <mat-icon class="hint-icon">info</mat-icon>
    <p>{{ text }}</p>
  </div>
</div>
